import { Thunk } from 'store/types';
import { navigateToProtectedRoute } from 'store/authentication/actions';

export const GET_DEEPLINK_ACTION = 'DEEPLINK.GET_DEEPLINK_ACTION';
export const GET_DEEPLINK_ACTION_SUCCESS = 'DEEPLINK.GET_DEEPLINK_ACTION_SUCCESS';
export const GET_DEEPLINK_ACTION_FAIL = 'DEEPLINK.GET_DEEPLINK_ACTION_FAIL';

export const RESET_DEEPLINK = 'DEEPLINK.RESET_DEEPLINK';
export const SET_DEEPLINK_URL = 'DEEPLINK.SET_DEEPLINK_URL';

export const getDeepLinkAction = (id: string) => ({
  type: GET_DEEPLINK_ACTION,
  payload: {
    client: 'events',
    request: {
      method: 'get',
      url: `/events/${id}`
    }
  }
});

export const setDeepLinkUrl = (url: string) => ({
  type: SET_DEEPLINK_URL,
  payload: {
    url
  }
});

export const resetDeepLink = () => ({
  type: RESET_DEEPLINK
});

export const navigateAndReset = (redirectUrl: string): Thunk => async dispatch => {
  dispatch(navigateToProtectedRoute(redirectUrl));
  dispatch(resetDeepLink());
};
